module.exports = __webpack_public_path__ + "fonts/avenir/aaf11848-aac2-4d09-9a9c-aac5ff7b8ff4.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/avenir/aaf11848-aac2-4d09-9a9c-aac5ff7b8ff4.ttf
// module id = 42
// module chunks = 0